export default __webpack_public_path__ + "static/media/unknownChair.b514e857.jpg";